export class InventoryGcpDisk {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSizeBytes",
            "baseName": "diskSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "diskName",
            "baseName": "diskName",
            "type": "string",
            "format": ""
        },
        {
            "name": "deviceName",
            "baseName": "deviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "isBootDisk",
            "baseName": "isBootDisk",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "throughput",
            "baseName": "throughput",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return InventoryGcpDisk.attributeTypeMap;
    }
    constructor() {
    }
}
